import { mapURL } from "../constants";
import domWrap from "../utils/domWrap";
import lightbox from "../utils/lightbox";
import scrollTrack from "../utils/scrollTrack";
import userTrack from "../utils/userTrack";

export default async html => { // 'html'

	userTrack();
	scrollTrack();
	[...document.querySelectorAll('a[map]')].forEach(mapLink => {
		mapLink.setAttribute('href',mapURL + encodeURIComponent(mapLink.getAttribute('map') || mapLink.textContent))
		mapLink.setAttribute('target','_blank');
	});

	[...document.querySelectorAll('a[phone]')].forEach(phoneLink => phoneLink.setAttribute('href',`tel:${phoneLink.textContent}`));

	domWrap(document.body)
	.on('click','[clickable]',function(event){
		const link = this.querySelector('a[default],a');
		if(link && event.target !== link) {
			if((link.getAttribute('href') || '').indexOf('#') !== -1){
				domWrap(link).trigger('click');
			}
			else {
				window.location = link.getAttribute('href');
			}
		}
	})
	// Sales page
	.on('click','[data-sp-popup]',function(e){
		e.preventDefault();
        lightbox(document.querySelector(this.getAttribute("data-sp-popup")).innerHTML);
	})
	.on('click','a[data-sp-autoscroll]',function(e){
		if (this.hash !== "") {
            e.preventDefault();

            let hash = this.hash;

			document.body.scroll({
				top: domWrap(document.querySelector(hash)).offset().top,
				behavior: 'smooth' 
			});
            window.location.hash = hash;
        }
	});

	[...document.querySelectorAll('iframe[src*="jwplatform"]')].forEach(iframe => iframe.parentElement.classList.add('vid-holder'));
};